import gql from 'graphql-tag';

export const CREATE_PROVISIONAL_PAYMENT_LOG = gql`
  mutation CreateProvisionalPaymentLog($data: PaymentInput!) {
    paymentLog: createProvisionalPaymentLog(data: $data) {
      id
    }
  }
`;
